const audioExtensions = new Set<string>(["wav", "aif", "aiff"]);

export const isAudioFile = (extension: string): boolean => {
    return audioExtensions.has(extension.toLowerCase());
};
